import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MainContainer } from '../MainContainer';
import { getOffices, createOffice, updateOffice } from '../../actions/officeAction';
import { getAllCategory } from '../../actions/category.action';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import OfficeList from './OfficeList';
import OfficeFormModal from './OfficeFormModal';
import Loader from '../../components/Loader';

const OfficePage = () => {
    const dispatch = useDispatch();
    const { offices, officeLoading, officeError } = useSelector((state) => state.office);
    const { user, authenticate } = useSelector((state) => state.auth);
    const [showModal, setShowModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [formItem, setFormItem] = useState({
        name: '',
        address: '',
        categories: [],
        accentColor: '#6366f1',
        coverImage: null,
        coverImageFile: null,
        removeCoverImage: false,
        watermarkMedia: null,
        watermarkImage: '',
        watermarkImageFile: null,
        removeWatermarkImage: false,
    }); // categoryIds → categories

    useEffect(() => {
        dispatch(getOffices());
    }, []);

    const handleOpenModal = (office = null) => {
        setCurrentId(office?._id || null);
        setFormItem({
            name: office?.name || '',
            address: office?.address || '',
            categories: office?.categories?.map((cat) => cat._id) || [], // categoryIds → categories
            accentColor: office?.accentColor || '#6366f1',
            coverImage: office?.coverImage || null,
            coverImageFile: null,
            removeCoverImage: false,
            watermarkMedia: office?.watermarkMedia || null,
            watermarkImage: office?.watermarkImage || '',
            watermarkImageFile: null,
            removeWatermarkImage: false,
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentId(null);
        setFormItem({
            name: '',
            address: '',
            categories: [],
            accentColor: '#6366f1',
            coverImage: null,
            coverImageFile: null,
            removeCoverImage: false,
            watermarkMedia: null,
            watermarkImage: '',
            watermarkImageFile: null,
            removeWatermarkImage: false,
        });
    };

    const handleSubmit = async () => {
        try {
            if (currentId) {
                await dispatch(updateOffice(currentId, formItem));
            } else {
                await dispatch(createOffice(formItem));
            }
            dispatch(getOffices());
            handleCloseModal();
        } catch (error) {
            alert(error.payload?.error || 'Ошибка сохранения офиса');
        }
    };

    if (officeLoading) {
        return <Loader />;
    }

    return (
        <MainContainer type="add" title="Настройки офисов">
            <Row>
                <Col>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleOpenModal()}
                        style={{ marginBottom: '10px' }}
                    >
                        Добавить офис
                    </button>
                </Col>
            </Row>
            <OfficeList offices={offices} onEdit={handleOpenModal} officeError={officeError} />
            <OfficeFormModal
                show={showModal}
                handleClose={handleCloseModal}
                onSubmit={handleSubmit}
                currentId={currentId}
                formItem={formItem}
                setFormItem={setFormItem}
            />
        </MainContainer>
    );
};

export default OfficePage;
